import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EntityActionFactory, EntityCache, HttpUrlGenerator } from "@ngrx/data";
import { Store } from "@ngrx/store";
import { ApiResponse, RestService } from "@recore-solutions/nstar-lib";
import { Observable, of } from "rxjs";
import { catchError, delay, map, switchMap, tap } from "rxjs/operators";
import { NstarDataService } from "src/app/nstar-data.service";
import { environment } from "src/environments/environment";
import { ListingAudit } from "./listing-audit";

@Injectable({
	providedIn: "root",
})
export class ListingAuditDataService extends NstarDataService<ListingAudit> {
	constructor(
		protected httpClient: HttpClient,
		protected httpUrlGenerator: HttpUrlGenerator,
		protected restService: RestService,
		protected entityCacheStore: Store<EntityCache>,
		protected entityActionFactory: EntityActionFactory
	) {
		super("ListingAudit", httpClient, httpUrlGenerator, entityCacheStore, entityActionFactory);
	}

	getListingAuditApiResponse(queryParams?: Record<string, any>): Observable<ListingAudit[]> {
		if (!queryParams.listingSK) {
			return of([]);
		}
		return this.restService
			.get<ApiResponse<ListingAudit, []>>(
				environment.endpoints.listingAudit,
				new HttpParams({ fromObject: queryParams })
			)
			.pipe(
				tap(this.dispatchRelatedRecordActions),
				map(this.mapResponseToRecords),
				catchError(() => of([]))
			);
	}

	getAll(): Observable<ListingAudit[]> {
		return this.getListingAuditApiResponse();
	}

	getWithQuery(params: Record<string, any>): Observable<ListingAudit[]> {
		return this.getListingAuditApiResponse(params);
	}

	deleteAuditRecord(queryParams: { listingSK: number; listingAuditSK: number }) {
		return this.restService
			.delete(environment.endpoints.listingAudit, {
				params: new HttpParams({ fromObject: queryParams }),
			})
			.pipe(
				delay(200),
				switchMap(() => this.getWithQuery({ listingSK: queryParams.listingSK }))
			);
	}
}
